export default __webpack_public_path__ + "static/media/three.1654a08f.jpeg";